// ─── Backend Payment Error Codes ─────────────────────────────────────────────
// Opaque codes returned by the backend (authorizeZeroAmountPayment mutation).
export enum PaymentErrorCode {
  PaymentDeclined = "PAYMENT_DECLINED",
  PaymentDeclined478 = "478-ERROR",
  InvalidExpirationDate = "INVALID_EXPIRATION_DATE",
  InvalidPhoneNumber = "INVALID_PHONE_NUMBER",
  InvalidBillingEmail = "INVALID_BILLING_EMAIL",
  InvalidBillingAddress = "INVALID_BILLING_ADDRESS",
  UnknownPaymentError = "UNKNOWN_PAYMENT_ERROR",
}
